'use client';

export { default } from './BottomNavigation';
export { default as bottomNavigationClasses } from './bottomNavigationClasses';
export * from './bottomNavigationClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/BottomNavigation/index.js
// module id = 900
// module chunks = 25